import * as PIXI from 'pixi.js';
import { Layout } from 'js/layouts/WaitingScreen';

export class WaitingScreen {
  private readonly layout: Layout;

  constructor(parent: PIXI.Container) {
    this.layout = new Layout();
    parent.addChild(this.layout.root);
    const interval = setInterval(() => this.layout.spinner.angle -= 45, 100);
    this.layout.root.onDestroyed.addOnce(() => clearInterval(interval));
  }

  public destroy(): void {
    this.layout.root.destroy();
  }
}